<template id="ProcessandoPedido">
    <v-ons-page id="ProcessandoPedidoPage">
      <v-ons-row width="90%" style="align-itens:center; width:90% !important;">
        <v-ons-col width="90%" style="margin-bottom:90px;">
          <h3 style="text-align:left; margin:30px; margin-top:90px; font-size:50px">Aguarde!
          <br>Estamos processando seu pedido.<br><br><br></h3>
          <!-- <p class="book" style="margin:30px;text-align:left; font-size:30px">Não esqueça de tomar um copo d'água entre uma cerveja e outra.</p> -->
        </v-ons-col>
      </v-ons-row>
    </v-ons-page>
</template>

<style>
</style>

<script>
export default {
  name: 'ProcessandoPedido',
  key: 'ProcessandoPedido',
  props: ['pageStack'],
  mounted() {
  }
}
</script>